import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — react-icons + React 19 typings
import {
  FaBook as FaBookRaw,
  FaChartBar as FaChartBarRaw,
  FaComments as FaCommentsRaw,
  FaClipboardList as FaClipboardListRaw,
  FaCog as FaCogRaw,
  FaFileAlt as FaFileAltRaw,
  FaFilePdf as FaFilePdfRaw,
  FaSignal as FaSignalRaw,
  FaUserFriends as FaUserFriendsRaw,
} from 'react-icons/fa';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaBook: any = FaBookRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaChartBar: any = FaChartBarRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaComments: any = FaCommentsRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaClipboardList: any = FaClipboardListRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaCog: any = FaCogRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaFileAlt: any = FaFileAltRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaFilePdf: any = FaFilePdfRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaSignal: any = FaSignalRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaUserFriends: any = FaUserFriendsRaw;

const SideNav = styled.aside`
  border: 1px solid color-mix(in srgb, var(--outline) 80%, transparent);
  border-radius: 14px;
  background: color-mix(in srgb, var(--surface) 92%, transparent);
  overflow: hidden;
`;

const SideNavHead = styled.div`
  padding: 0.9rem 0.95rem;
  border-bottom: 1px solid color-mix(in srgb, var(--outline) 80%, transparent);
`;

const SideNavTitle = styled.div`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text);
`;

const SideNavSub = styled.p`
  margin: 0.2rem 0 0;
  color: var(--textSecondary, #64748b);
  font-size: 0.75rem;
`;

const SideLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.66rem 0.95rem;
  font-size: 0.84rem;
  font-weight: 700;
  color: var(--textSecondary, #64748b);
  text-decoration: none;
  border-left: 2px solid transparent;
  &:hover {
    background: color-mix(in srgb, var(--surfaceVariant) 42%, transparent);
    color: var(--text);
  }
  &.active {
    color: var(--text);
    border-left-color: #3b82f6;
    background: color-mix(in srgb, #3b82f6 14%, transparent);
  }
`;

const SideDivider = styled.div`
  height: 1px;
  background: color-mix(in srgb, var(--outline) 80%, transparent);
`;

type ClassSectionSidebarProps = {
  classId: string;
  className: string;
  subLabel?: string;
  showSettingsLink?: boolean;
  settingsHref?: string;
  children?: React.ReactNode;
};

export default function ClassSectionSidebar({
  classId,
  className,
  subLabel = 'Class workspace',
  showSettingsLink = true,
  settingsHref = '/profile',
  children,
}: ClassSectionSidebarProps) {
  const classBase = `/classroom-teacher/classes/${encodeURIComponent(classId)}`;
  return (
    <SideNav aria-label="Class sections">
      <SideNavHead>
        <SideNavTitle>{className}</SideNavTitle>
        <SideNavSub>{subLabel}</SideNavSub>
      </SideNavHead>
      <SideLink to={classBase} end>
        <FaSignal size={14} aria-hidden />
        Overview
      </SideLink>
      <SideLink to={`${classBase}/syllabus`}>
        <FaFilePdf size={14} aria-hidden />
        Syllabus
      </SideLink>
      <SideLink to={`${classBase}/lessons`} end>
        <FaBook size={14} aria-hidden />
        Lessons
      </SideLink>
      <SideLink to={`${classBase}/assignments`}>
        <FaClipboardList size={14} aria-hidden />
        Assignments
      </SideLink>
      <SideLink to={`${classBase}/discussion`}>
        <FaComments size={14} aria-hidden />
        Discussion
      </SideLink>
      <SideLink to={`${classBase}/students`}>
        <FaUserFriends size={14} aria-hidden />
        Students
      </SideLink>
      <SideLink to={`${classBase}/textbook`}>
        <FaFileAlt size={14} aria-hidden />
        Textbook
      </SideLink>
      <SideLink to={`${classBase}/grades`}>
        <FaClipboardList size={14} aria-hidden />
        Grading
      </SideLink>
      <SideDivider />
      <SideLink to="/classroom-teacher/analytics">
        <FaChartBar size={14} aria-hidden />
        Class Stats
      </SideLink>
      {showSettingsLink ? (
        <SideLink to={settingsHref}>
          <FaCog size={14} aria-hidden />
          Settings
        </SideLink>
      ) : null}
      {children}
    </SideNav>
  );
}
